export enum OperationUrls {
  AllVoyage = "Operation/AllVoyage",
  NewVoyage = "Operation/NewVoyage",
  Operation = "Operation/",
  EditVoyage = "/EditVoyage",
  DeleteVoyage = "/DeleteVoyage",
}
